import { useAuthContext } from '@contexts/AuthProvider';
import { usePermissionContext } from '@contexts/PermissionProvider';
import { useLocation } from 'react-router-dom';
import { Sidebar, SidebarButton, SidebarSeparator } from '.';
import atelifinanceLogo from '../../assets/atelifinance.svg';
import { Icon } from '../Icon';

type Props = {
  collapsed: boolean;
  onClick: () => void;
};

export default function MenuSidebar(props: Props) {
  const location = useLocation();
  const { hasPermission } = usePermissionContext();
  const { logout, user } = useAuthContext();

  const menuItems = [
    {
      active: location.pathname === '/',
      label: 'Home',
      icon: <Icon children="home" />,
      arrow: false,
      url: '/',
      show: true,
    },
    {
      active: [
        '/budget-consolidado',
        '/budget-despesas-grid',
        '/budget-despesas-revisao',
        '/budget-receitas',
      ].includes(location.pathname),
      label: 'Gerenciamento',
      icon: <Icon children="bar_chart" />,
      subitems: [
        {
          label: 'Budget consolidado',
          url: '/budget-consolidado',
          show: hasPermission('budgetsConsolidated'),
        },
        {
          label: 'Budget despesas',
          url: '/budget-despesas-grid',
          show: hasPermission('budget_expense_lines'),
        },
        {
          label: 'Resumo e revisão de despesas',
          url: '/budget-despesas-revisao',
          show: hasPermission('budget_expense_lines'),
        },
        {
          label: 'Budget receitas',
          url: '/budget-receitas',
          show: hasPermission('budgets'),
        },
      ],
      arrow: true,
    },
    {
      active: [
        '/categorias',
        '/centros-custo',
        '/centros-custo-de-para',
        '/modelos-budget',
        '/upload-file',
        '/users',
        '/access',
        '/realizado',
        '/colaboradores',
        '/estimativa-colaboradores',
      ].includes(location.pathname),
      label: 'Operação',
      icon: <Icon children="pie_chart" />,
      subitems: [
        {
          label: 'Categorias',
          url: '/categorias',
          show: hasPermission('categories'),
        },
        {
          label: 'Centro de custo',
          url: '/centros-custo',
          show: hasPermission('costCenters'),
        },
        {
          label: 'Centro de custo de/para',
          url: '/centros-custo-de-para',
          show: hasPermission('costCentersFromTo'),
        },
        {
          label: 'Modelos de budget',
          url: '/modelos-budget',
          show: hasPermission('budgetTemplates'),
        },
        {
          label: 'Realizado',
          url: '/realizado',
          show: hasPermission('transactions'),
        },
        { label: 'Usuários', url: '/users', show: hasPermission('users') },
        {
          label: 'Níveis de acesso',
          url: '/access',
          show: hasPermission('accessGroups'),
        },
        {
          label: 'Colaboradores',
          url: '/colaboradores',
          show: hasPermission('collaborators'),
        },
        {
          label: 'Estimativa de folha',
          url: '/estimativa-colaboradores',
          show: hasPermission('collaborator_expenses'),
        },
      ],
      arrow: true,
    },
  ];
  return (
    <Sidebar collapsed={props.collapsed} className="bg-primary">
      <div className="sidebar-menu text-neutral-variant-40">
        {props.collapsed ? (
          <div className="icone-menu-close" onClick={props.onClick}>
            <Icon children="menu" />
          </div>
        ) : (
          <>
            <img
              src={atelifinanceLogo}
              width="186"
              alt="logo"
              className="side-logo"
            />
            <div className="icone-menu-open" onClick={props.onClick}>
              <Icon children="menu_open" />
            </div>
          </>
        )}
      </div>
      <SidebarSeparator />
      <div className="text-neutral-variant-40">
        {menuItems.map((item, index) => (
          <SidebarButton
            key={index}
            active={item.active}
            label={item.label}
            icon={item.icon}
            subitems={item.subitems}
            arrow={item.arrow}
            collapsed={props.collapsed}
            url={item.url || ''}
            onButtonClick={props.onClick}
          />
        ))}
      </div>
      <SidebarSeparator />
      <SidebarButton
        key={-1}
        active={['/me'].includes(location.pathname)}
        label={user?.name}
        url="/me"
        icon={<Icon children="person" />}
        collapsed={props.collapsed}
      />
      <SidebarButton
        key={-2}
        active={false}
        label={'Sair'}
        icon={<Icon children="logout" />}
        collapsed={true}
        onButtonClick={logout}
      />
    </Sidebar>
  );
}
